import * as React from "react";
import {Fields} from "userform/utils";
import {isMobile, isValidPan} from "utils";
import {IValidation} from "StateInterface";
import {googleLoginVersion, imageBaseUrl} from "config";
import {Link} from "react-router-dom";
import {RouteComponentProps} from "react-router-dom";
import "./styles.scss";
import Loading from "components/loading";
import Slider from "login/carousel";
import {partnerOfferings} from "./config";

export interface IUserInput {
    pan: string;
    mobile: string;
    otp: number;
}
export const defaultUserInput = {
    pan: "",
    mobile: "",
    otp: 0,
};
export const defaultValidationStatus = {
    status: false,
    msg: "",
    type: "",
};
export const shubhloansLogo = `${imageBaseUrl}/img/logo/sl_new_logo1.png`;
export function updateUserInputForEmailUpdation(userInput: IUserInput, fieldName: string,
                                                value: string | number): IUserInput {
    const updatedUserInput = Object.assign({}, userInput);
    if (fieldName === Fields.MOBILE) {
        const regexForNumber = /^\d+$/;
        if (String(value).length <= 10 && regexForNumber.test(String(value))) {
            updatedUserInput.mobile = String(value);
        }
    } else if (fieldName === Fields.PAN_NUMBER && String(value).length <= 10) {
        updatedUserInput.pan = String(value).toUpperCase();
    } else if (fieldName === Fields.OTP) {
        updatedUserInput.otp = Number(value);
    }
    return updatedUserInput;
}

export function validateUpdateEmailFields(mobile: string, pan: string): IValidation {
    const validation: IValidation = {
        status: false,
        msg: "",
        type: "",
    };
    if (!isMobile(mobile)) {
        validation.msg = "Incorrect Mobile Number";
        validation.type = Fields.MOBILE;
    } else if (!isValidPan(pan)) {
        validation.msg = "Incorrect Pan Number";
        validation.type = Fields.PAN_NUMBER;
    } else { validation.status = true; }
    return validation;
}
export function getUpdateEmailResponse(statusCode) {
    const response = {
        status: null,
        msg: null,
    };
    if (statusCode === 200) {
        response.status = "SUCCESS";
        response.msg = "Email has been updated successfully!";
    } else if (statusCode === 401) {
        response.status = "FAILURE";
        response.msg = "Incorrect Otp!";
    } else if (statusCode === 403) {
        response.status = "FAILURE";
        response.msg = "Something went wrong. Please contact our customer support team @ +919019900199";
    }
    return response;
}
export function getUpdateEmailRelatedMessages(userFound, emailUpdateResponse) {
    let msgDetails = {
        status: null,
        msg: null,
    };
    if (userFound === "FAILURE") {
        msgDetails.status = false;
        msgDetails.msg = "Sorry we could not find a user with the entered PAN and MOBILE!";
    } else {
        msgDetails = emailUpdateResponse;
    }
    return msgDetails;
}

export function RenderTestimonials() {
    const testimonialData = [
        {
            name: "Vasim Pathan",
            location: "Ahmedabad",
            comment: `"I am grateful to MyShubhLife who understands my condition and helped me see out crunch` +
                `time and it was quick approval and disbursement. I would be happy to endorse this` +
                `brand to others and spread words for them."`,
            rating: 5,
            imageUrl: `${imageBaseUrl}/img/testimonials/testimonial_vasim_pathan.jpg`,
        },
        {
            name: "Muralidhara",
            location: "Bengaluru",
            comment: `"Before taking a loan from MyShubhLife I was facing financial problems. Now my problems` +
                `are solved because of MyShubhLife. Thank you MyShubhLife for being my financial partner in time of need."`,
            rating: 5,
            imageUrl: `${imageBaseUrl}/img/testimonials/testimonial_muralidhara.jpg`,
        },
        {
            name: "Suraj M A",
            location: "Bengaluru",
            comment: `"I received very good service from MyShubhLife for my personal loan application. The staff at MyShubhLife` +
                `is extremely helpful. Thank you so much MyShubhLife team for the quick and hassle-free procedure."`,
            rating: 5,
            imageUrl: `${imageBaseUrl}/img/testimonials/testimonial_suraj_ma.jpg`,
        },
    ];
    return(
        <section className="mb-5 pb-2 bg-white testimonial-container" >
            <div className="container-fluid px-md-3">
                <p className="subheading2 mt-5 text-center">TESTIMONIALS</p>
                <h2 className="text-center pb-4" style={{color: "#000000"}}>That's what our customer say</h2>
                <div className="testimonial-card-section">
                    {testimonialData.map((item, index) => {
                        return (
                            <div className="card-3" key={index}>
                                <div className="card shadow border-0 card-testimonial m-md-3">
                                    <div className="card-body pt-5">
                                        <img src={item.imageUrl}
                                             style={{width: 120, height: 130,
                                                 borderRadius: "50%", paddingBottom: "20px"}}
                                             alt="User Image"/>
                                            <p className="testimonial-comment">{item.comment}</p>
                                            <div>
                                            <span className="customer-name mt-4">
                                                {item.name},
                                                <br/>
                                                {item.location}
                                            </span>
                                                <span className="float-right">
                                                {Array.from(Array(item.rating).keys()).map((i, ind) => {
                                                    return(
                                                        <i key={ind} className="fa fa-star mr-2 rating-star"/>
                                                    );
                                                })}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    } )}
                </div>
            </div>
        </section>
    );
}

const loanBreakoutDetails = [
    {
        title: "Loan Amount:",
        value: "₹1,00,000",
    },
    {
        title: "Duration:",
        value: "1 year",
    },
    {
        title: "Interest Rate:",
        value: "₹26%",
    },
    {
        title: "EMI = ",
        value: "₹9,553",
    },
    {
        title: "Total Interest = ",
        value: "₹14,636",
    },
    {
        title: "Processing Fee (@2%):",
        value: "₹2,000 + GST",
    },
    {
        title: "Total Cost = ",
        value: "₹16,996",
    },
    {
        title: "APR = ",
        value: "29.9%.",
    },
];

export function RenderLoginSection(props) {
    return (
        <div className="bg-light">
            <div className="row login-row-style bg-light" style={{maxWidth: "1400px", margin: "auto"}}>
                <div className="col-md-6 bg-light login-container px-md-5 offer-wrapper">
                    <div className="login-card-1  p-md-5">
                        { props.partner && partnerOfferings[props.partner]?.offers && partnerOfferings.hasOwnProperty(props.partner) ? 
                            <div className="offers">
                                <h2>We Offer</h2>
                                <ul className="text-dark pl-md-5 ol">
                                {
                                    partnerOfferings[props.partner]?.offers?.map((offer, index) => {
                                        return <li key={index}>{offer}</li>;
                                    })
                                }
                                </ul>
                            </div> : <div>
                                <h3 className="title-text-dark pl-0">Important Information on Personal Loans</h3>
                                <p className="title-text">Repayment Period: 3 months (min.) to 36 months (max.)<br/>
                                    Max. Annual Percentage Rate (APR): 78%</p>
                                <h3 className=" title-text-dark pl-0">Representative Example</h3>
                                <p className="title-text">
                                    This is an example to show cost involved and interest calculations. Actual amount,
                                    tenure, interest rate & processing fee will depend on the risk proﬁle of the user.
                                </p>
                                <div className="display-flex-wrap">
                                    {
                                        loanBreakoutDetails.map((item, index) => {
                                            return (
                                                <div className="financial-wellness-item" key={index}>
                                                    <img className="check-arrow"
                                                         src="https://www.myshubhlife.com/img/tick-check.svg"
                                                         alt="financial-wellness"/>
                                                    <div className="why-financial-wellness-content">
                                                        <span className="title-text">{item.title}</span> {item.value}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className="col-md-6 px-md-5 login-container">
                    <div className="login-card-2 p-md-5 bg-light">
                        <div className="card border-0 shadow" style={{backgroundColor: "#FFF", maxWidth: "400px", padding: "20px 0"}}>
                            {
                                props.partner && partnerOfferings[props.partner]?.offers && partnerOfferings.hasOwnProperty(props.partner) ? 
                                <div className='partner-logo'>
                                    <h1>In association with</h1>
                                    <img src={partnerOfferings[props.partner].logo} alt="partner" />
                                </div> :
                                <div>
                                    <h3 className="title-text-dark-signIn">Sign-in to access our Products</h3>
                                    <ul className="text-dark ul" style={{fontWeight: "bold"}}>
                                        <li>Personal Loans</li>
                                        <li>Insurance</li>
                                        <li>Mutual Funds</li>
                                        <li>And More!</li>
                                    </ul> 
                                </div>
                            }
                            <div className="justify-content-center pt-md-4 login-btn-container m-auto" style={{maxWidth: 300}}>
                                {googleLoginVersion === "V2" ? 
                                    <div>
                                        <div id="google-sign-in" style={{margin: "auto", width: "fit-content"}}></div>
                                    </div> :
                                    <button id="google-sign-in" className="btn text-center d-flex justify-content-center sign-in-btn w-full">
                                        <span className="google-icon-text">G</span>
                                        <span className="google-text-2">Sign in with Gmail</span>
                                    </button>
                                }
                                <Link to={"/email/updateEmail"} style={{textDecoration: "none"}}>
                                    <button className="btn change-email-btn btn-block">
                                        Click here to change your Email Id
                                    </button>
                                </Link>
                                <p className="text-center pt-3 terms-check-text">
                                    By clicking Sign In, you accept our<span className="text-dark">
                                    <a href={`${imageBaseUrl}/tandc.html`}> Terms & Conditions </a> </span>
                                    and <span className="text-dark"><a href={`${imageBaseUrl}/privacy.html`}>
                                    Privacy Policy.</a></span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function RenderFooter() {
    return(
        <section className="bg-light">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-sm-6 pl-md-5 footer-content">
                                <h6>ABOUT</h6>
                                <ul className="para-steps">
                                    <li><a href={`${imageBaseUrl}/index.html#!#page-top`}>Home</a></li>
                                    <li><a href={`${imageBaseUrl}/about.html`}>Our Story</a></li>
                                    <li><a href={`${imageBaseUrl}/about.html#!#1`}>Our Team</a></li>
                                    <li><a href={`${imageBaseUrl}/about.html#!#2`}>Our Advisor</a></li>
                                    <li><a href={`${imageBaseUrl}/about.html#!#3`}>Our Investors</a></li>
                                </ul>
                            </div>
                            <div className="col-sm-6 pl-md-5 footer-content">
                                <h6>OTHERS</h6>
                                <ul className="para-steps">
                                    <li><a href={`${imageBaseUrl}/media.html`}>Media</a></li>
                                    <li><a href={`${imageBaseUrl}/careers.html`}>Careers</a></li>
                                    <li><a href={`${imageBaseUrl}/faq.html`}>FAQ</a></li>
                                    <li><a href={`${imageBaseUrl}/our-core-principles.html`}>Our Principles</a></li>
                                    <li><a href={`${imageBaseUrl}/privacy-policy.html`}>Privacy Policy</a></li>
                                    <li><a href={`${imageBaseUrl}/terms-and-conditions.html`}>Terms & Conditions</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row justify-content-center">
                            <div className="col-sm-6 pl-md-5 footer-content">
                                <h6>ADDRESS</h6>
                                <ul className="para-steps">
                                    <li>Datasigns Technologies Pvt. Ltd.,<br/>
                                        NOVA MILLER, #333,<br/>
                                        Thimmiah Road, Vasanth Nagar,<br/>
                                        Bengaluru - 560052</li>
                                </ul>
                            </div>
                            <div className="col-sm-6 pl-md-5 footer-content">
                                <h6>CONTACT</h6>
                                <ul className="para-steps">
                                    <li>+91-90199-00199</li>
                                    <li>support@myshubhlife.com</li>
                                    <li>
                                        <ul className="para-steps">
                                            <a href="https://www.facebook.com/MyShubhLifeApp/">
                                                <li className="mr-3 d-inline">
                                                    <i className="fa fa-facebook-square text-secondary"/>
                                                </li>
                                            </a>
                                            <a href="https://www.linkedin.com/company/myshubhlife/">
                                                <li className="mr-3 d-inline">
                                                    <i className="fa fa-linkedin text-secondary"/>
                                                </li>
                                            </a>
                                            <a href="https://twitter.com/myshubhlife">
                                                <li className="mr-3 d-inline">
                                                    <i className="fa fa-twitter text-secondary"/>
                                                </li>
                                            </a>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center bg-dark">
                <p className="text-light text-center pt-3">
                    © {new Date().getFullYear()} MyShubhLife. All Rights Reserved.</p>
            </div>
        </section>
    );
}

function renderCard(props) {
    if (!props.config.showCoBrandingCard) {
        return <div/>;
    }
    if (props.config.sliderItems.length > 1) {
        return <Slider
            items={this.props.config.sliderItems}
        />;
    }
    return <div className="card" style={{width: 300}}>
        <div className="card-body" style={{
            fontSize: 25,
            color: "#007bff", textAlign: "center",
        }}>
            <br/>
            <br/>
            <span>{props.config.loginCardText
                ? props.config.loginCardText
                : <span>Excited to partner <br/>with</span>}
                </span>
        </div>
        <br/>
        <br/>
        <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
            <img className="card-img-top"
                 src={props.config.sliderItems[0].src}/>
        </div>
        <br/>
        <br/>
        <br/>
        <br/>
    </div>;
}
export function PartnerLoginScreen(props) {
    return (
        <div className="new-login-container" style={{background: `${props.config.loginBgColor}`}}>
            <Loading
                active={props.loading}/>
            <div className="container-fluid">
                <div className="row p-3">
                    <div className="col-lg-1 col-md-1 col-sm-12 col-12">
                    </div>
                    <div className="col-lg-10 col-md-10 col-sm-12 col-12">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12 col-12"
                                 style={{
                                     display: "flex", justifyContent: "center",
                                     alignItems: "center", flexDirection: "column", fontFamily: "Poppins",
                                 }}>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-1 p-2">
                                        <div style={{
                                            fontSize: "1.5em",
                                            fontFamily: "Poppins", color: "#FFFFFF",
                                        }}>
                                            <div style={{lineHeight: 1.5}}>Get the best in class
                                                loan offers with
                                                <br/><b>MyShubhLife</b>
                                            </div>
                                            <br/>
                                            <div style={{fontSize: 17, marginTop: -30}}>
                                                By clicking sign in, you accept our&nbsp;
                                                <span style={{fontWeight: "bold"}}>
                                                            <a style={{color: "#FFFFFF"}}
                                                               href={`${imageBaseUrl}/tandc.html`}
                                                               target="_blank">Terms & Conditions
                                                            </a>
                                                        </span> and&nbsp;
                                                <span style={{color: "#FFFFFF", fontWeight: "bold"}}>
                                                            <a style={{color: "#FFFFFF"}}
                                                               href={`${imageBaseUrl}/privacy.html`}
                                                               target="_blank">Privacy Policy
                                                            </a>
                                                </span>.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 p-0" id="google-sign-in" style={{
                                        marginTop: 15,
                                        display: "flex", justifyContent: "center", alignItems: "center",
                                        background: "#FFFFFF", color: "#4285f4",
                                        cursor: "pointer", height: 75,
                                    }}>
                                                <span className="login-btn" style={{color: "#4285f4", fontSize: 22}}>
                                                    <b>Sign in with Google</b>
                                                </span>
                                    </div>
                                    <div className="col-12 text-3 p-0" style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center", height: 40, textAlign: "left",
                                        fontSize: 17, marginTop: 15, marginBottom: 10, color: "#FFFFFF",
                                    }}>
                                        Already registered?&nbsp;
                                        <span className="login-btn" id="btn-login-existing-user" style={{color: "#FFFFFF"}}>
                                            <b>Login here</b>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-12 mt-4"
                                 style={{
                                     display: "flex", alignItems: "center",
                                     flexDirection: "column",
                                 }}>
                                <div className="row">
                                    {renderCard(props)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-1 col-md-1 col-sm-12 col-12">
                    </div>
                </div>
                <div>
                    <div className="row py-3">
                        <div className="col-lg-1 col-md-1 col-sm-12 col-12">
                        </div>
                        <div className="col-lg-10 col-md-10 col-sm-12 col-12" style={{
                            textAlign: "center",
                            fontSize: "1.5em", paddingLeft: 0,
                            fontFamily: "poppins", marginTop: 10, color: "#FFFFFF",
                        }}>
                            Get loans for all your personal needs.<br/>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="row">
                                    <div className="col-lg-3 col-md-3 col-sm-6 col-6" style={{
                                        display: "flex",
                                        justifyContent: "center", alignItems: "center", paddingTop: 40,
                                        flexDirection: "column",
                                    }}>
                                        <img style={{width: "60%", marginTop: 20}}
                                             src={`${imageBaseUrl}/img/home/education.png`}/>
                                        <span style={{fontSize: 20, paddingTop: 20}}>
                                                    <b>Education</b></span>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6 col-6" style={{
                                        display: "flex",
                                        justifyContent: "center", alignItems: "center", paddingTop: 20,
                                        flexDirection: "column",
                                    }}>
                                        <img style={{width: "60%", marginTop: 20}}
                                             src={`${imageBaseUrl}/img/home/marriage.png`}/>
                                        <span style={{fontSize: 20, paddingTop: 40}}>
                                            <b>Marriage</b>
                                        </span>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6 col-6" style={{
                                        display: "flex",
                                        justifyContent: "center", alignItems: "center", paddingTop: 20,
                                        flexDirection: "column",
                                    }}>
                                        <img style={{width: "60%", marginTop: 40}}
                                             src={`${imageBaseUrl}/img/home/medical.png`}/>
                                        <span style={{fontSize: 20, paddingTop: 25}}>
                                                    <b>Medical</b></span>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6 col-6" style={{
                                        display: "flex",
                                        justifyContent: "center", alignItems: "center", paddingTop: 20,
                                        flexDirection: "column",
                                    }}>
                                        <img style={{width: "60%", marginTop: 40}}
                                             src={`${imageBaseUrl}/img/home/more.png`}/>
                                        <span style={{fontSize: 20, paddingTop: 25}}> and <b> More </b></span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12" style={{
                                textAlign: "center",
                                fontSize: 15,
                            }}><br/>
                                Interest rate from 18% - 30% per annum on a reducing balance basis,
                                depending on customer's risk profile and loan tenure.<br/>Example, on a loan
                                of Rs. 1,00,000 for 1 year the EMI will be Rs. 9,553 and the total interest
                                paid will be Rs. 14,636
                            </div>
                        </div>
                        <div className="col-lg-1 col-md-1 col-sm-12 col-12">
                        </div>
                    </div>
                </div>
            </div>
            <div className="row py-3 form-footer-container">
                <div className="col-lg-1 col-md-1 col-sm-12 col-12">
                </div>
                <div className="col-lg-10 col-md-10 col-sm-12 col-12">
                    {props.config.showCoBrandingInFooter
                    && <div className="row" style={{display: "flex", justifyContent: "center"}}>
                        <div className="col-12" style={{display: "flex", justifyContent: "center"}}>
                            {props.config.loginCardText
                                ? props.config.loginCardText
                                : "Excited to partner with"}
                        </div>
                        <div className="col-12" style={{display: "flex", justifyContent: "center"}}>
                            <img className="card-img-footer"
                                 src={props.config.sliderItems[0].src}/>
                        </div>
                    </div>}
                    <div className="row">
                        <div className="col-lg-5 col-md-5 col-sm-12 col-12"
                             style={{display: "flex", flexDirection: "column"}}>
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-12"
                                     style={{fontSize: 15}}>
                                    <br/><br/>
                                    <b>Contact Us</b><br/>
                                    +91 90199-00199<br/>
                                    support@myshubhlife.com<br/>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2 col-2 d-md-flex d-sm-none d-none">
                        </div>
                        <div className="col-lg-5 col-md-5 col-sm-12 col-12"
                             style={{
                                 display: "flex",
                                 flexDirection: "column",
                             }}>
                            <div className="row">
                                        <span style={{paddingLeft: 15}}><br/><b>Office Address</b><br/>
                                            Datasigns Technologies Pvt. Ltd.,<br/>
                                            NOVA MILLER,<br/>
                                            333. Thimmiah Road, <br/>
                                            Vasanth Nagar ,<br/>
                                            Bengaluru - 560052<br/></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-1 col-md-1 col-sm-12 col-12">
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12"
                     style={{textAlign: "center", fontSize: 15}}>
                    <br/>
                    MyShubhLife is a product of Datasigns Technologies Private
                    Limited. © {new Date().getFullYear()} MyShubhLife, All Rights Reserved.
                </div>
            </div>
        </div>
    );
}
